/**
 * Classes service for class folder management
 * Handles CRUD operations for teacher class organization
 */

import { apiService } from './api';
import {
  Class,
  ClassWithMetrics,
  CreateClassRequest,
  CreateClassResponse,
  UpdateClassRequest,
  UpdateClassResponse,
  DeleteClassResponse,
  ListClassesResponse,
  GetClassResponse,
} from '@/types/class';

class ClassesService {
  /**
   * Create a new class folder
   */
  async createClass(request: CreateClassRequest): Promise<Class> {
    const response = await apiService.post<CreateClassResponse>('/classes', request);
    return response.class;
  }

  /**
   * List all classes for the current teacher with session counts
   */
  async listClasses(): Promise<ClassWithMetrics[]> {
    const response = await apiService.get<ListClassesResponse>('/classes');
    return response.classes;
  }

  /**
   * Get class details with session count
   */
  async getClass(classId: string): Promise<ClassWithMetrics> {
    const response = await apiService.get<GetClassResponse>(`/classes/${classId}`);
    return response.class;
  }

  /**
   * Update class details (name, description, color)
   */
  async updateClass(classId: string, request: UpdateClassRequest): Promise<Class> {
    const response = await apiService.put<UpdateClassResponse>(`/classes/${classId}`, request);
    return response.class;
  }

  /**
   * Delete an empty class folder
   * Returns error if class contains sessions
   */
  async deleteClass(classId: string): Promise<void> {
    await apiService.delete<DeleteClassResponse>(`/classes/${classId}`);
  }
}

export const classesService = new ClassesService();
